// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J4KN","content":"styles_content__1nSrF"};